var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertOctagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 5.83301C10.4609 5.83301 10.834 6.2061 10.834 6.66634V9.99967C10.834 10.4599 10.4609 10.833 10.0007 10.833C9.54041 10.833 9.16732 10.4599 9.16732 9.99967V6.66634C9.16732 6.2061 9.54041 5.83301 10.0007 5.83301Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 12.4997C9.54041 12.4997 9.16732 12.8728 9.16732 13.333C9.16732 13.7932 9.54041 14.1663 10.0007 14.1663H10.009C10.4692 14.1663 10.8423 13.7932 10.8423 13.333C10.8423 12.8728 10.4692 12.4997 10.009 12.4997H10.0007Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9614 1.07709C6.11768 0.920805 6.32964 0.833008 6.55065 0.833008H13.4506C13.6717 0.833008 13.8836 0.920805 14.0399 1.07709L18.9232 5.96042C19.0795 6.1167 19.1673 6.32866 19.1673 6.54967V13.4497C19.1673 13.6707 19.0795 13.8826 18.9232 14.0389L14.0399 18.9223C13.8836 19.0785 13.6717 19.1663 13.4506 19.1663H6.55065C6.32964 19.1663 6.11768 19.0785 5.9614 18.9223L1.07806 14.0389C0.921782 13.8826 0.833984 13.6707 0.833984 13.4497V6.54967C0.833984 6.32866 0.921782 6.1167 1.07806 5.96042L5.9614 1.07709ZM6.89583 2.49967L2.50065 6.89485V13.1045L6.89583 17.4997H13.1055L17.5006 13.1045V6.89485L13.1055 2.49967H6.89583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertOctagon);
export default __webpack_public_path__ + "static/media/alert_octagon.013ed5274ba69cbf105251f901295496.svg";
export { ForwardRef as ReactComponent };